module.exports = __webpack_public_path__ + "img/more.e49d825a.svg";